<app-lang-switch position="absolute"></app-lang-switch>
<div class="container flex">
  <div [formGroup]="form" class="widget loginFormContainer p-6 flex flex-column gap-4">
    <img src="assets/images/logo.png" alt="Logo" class="appLogo" />
    <span class="text-center">{{ "auth.otp.title" | translate }}</span>
    <div class="flex flex-column gap-2 mb-3">
      <label for="otp" class="font-semibold">{{ "auth.otp.otp" | translate }}</label>
      <input pInputText (keyup)="onKeyUp($event)" id="otp" formControlName="otp" autocomplete="off" />
    </div>
    <app-button
      (click)="confirmOtp()"
      buttonText="auth.otp.activation_button"
      [block]="true"
      [disabled]="!form.valid"
    ></app-button>
  </div>
</div>
